var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "col-12 mt-3", attrs: { id: "timeline-container" } },
    [
      _c(
        "div",
        { staticClass: "nav-tabs-wrapper bb-0" },
        [
          _c("scrollable-container", [
            _c(
              "ul",
              { staticClass: "nav nav-tabs" },
              _vm._l(_vm.tabs, function (ref) {
                var name = ref.name
                var label = ref.label
                return _c(
                  "li",
                  {
                    key: "client-profile-" + name,
                    staticClass:
                      "nav-item clickable mr-0 mr-md-1 mr-xl-4 d-flex flex-row align-items-center",
                    class: _vm.activeItem(name) ? "nav-item-active" : "",
                    attrs: { id: "client-profile-" + name },
                    on: {
                      click: function ($event) {
                        return _vm.setCurrentTab(name)
                      },
                    },
                  },
                  [
                    _c("span", [
                      _c("a", {
                        staticClass: "nav-link grey-text text-darken-3",
                        domProps: { innerHTML: _vm._s(label) },
                      }),
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      [
                        name === "changelog" &&
                        _vm.isChangelog &&
                        _vm.loadingChangelog
                          ? _c("inline-loader", {
                              attrs: { width: "14px", height: "14px" },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                )
              }),
              0
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { id: "timeline-tabs-container" } },
        [
          _vm.loading
            ? _c(
                "vue-content-loading",
                { staticClass: "mt-4", attrs: { width: 1400, height: 1400 } },
                [
                  _c("rect", {
                    attrs: {
                      x: "150",
                      y: "0",
                      rx: "0",
                      ry: "0",
                      width: "350",
                      height: "35",
                    },
                  }),
                  _vm._v(" "),
                  _c("rect", {
                    attrs: {
                      x: "150",
                      y: "84",
                      rx: "5",
                      ry: "5",
                      width: "1200",
                      height: "300",
                    },
                  }),
                  _vm._v(" "),
                  _c("circle", { attrs: { cx: "70.77", cy: "125", r: "40" } }),
                  _vm._v(" "),
                  _c("rect", {
                    attrs: {
                      x: "66.84",
                      y: "83.67",
                      rx: "0",
                      ry: "0",
                      width: "14",
                      height: "800",
                    },
                  }),
                  _vm._v(" "),
                  _c("circle", { attrs: { cx: "69.77", cy: "490", r: "40" } }),
                  _vm._v(" "),
                  _c("rect", {
                    attrs: {
                      x: "150",
                      y: "450",
                      rx: "5",
                      ry: "5",
                      width: "1200",
                      height: "300",
                    },
                  }),
                  _vm._v(" "),
                  _c("circle", { attrs: { cx: "69.77", cy: "850", r: "40" } }),
                  _vm._v(" "),
                  _c("rect", {
                    attrs: {
                      x: "150",
                      y: "820",
                      rx: "5",
                      ry: "5",
                      width: "1200",
                      height: "300",
                    },
                  }),
                ]
              )
            : !_vm.isChangelog
            ? _c("timeline-list", {
                attrs: {
                  "timeline-list": _vm.timelineList,
                  "is-empty-timeline": _vm.isEmptyTimeline,
                  subscribers: _vm.subscribers,
                  details: _vm.details,
                  "client-profile-id": _vm.clientProfileId,
                  "board-id": _vm.boardId,
                  "client-username": _vm.clientUsername,
                  applications: _vm.applications,
                  "timeline-tab": _vm.timelineTab,
                  "loading-more-timeline": _vm.loadingMoreTimeline,
                  offset: _vm.offset,
                },
                on: {
                  filter: _vm.setCurrentTab,
                  "change-action": _vm.changeTimelineAction,
                  "load-time-line": _vm.loadTimeLine,
                },
              })
            : _c("client-profile-changelog", {
                attrs: {
                  "client-profile-id": _vm.clientProfileId,
                  "board-id": _vm.boardId,
                },
              }),
          _vm._v(" "),
          _c("activity-convert-modal", {
            attrs: {
              "modal-id": "activity-convert-modal",
              "client-profile-id": _vm.clientProfileId,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.loadingMoreTimeline
        ? _c("inline-loader", {
            staticClass: "pb-2 d-flex flex-column align-items-center",
            attrs: { width: "30px", height: "30px" },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }